import { ReactComponent as Logo } from './logo/appz-logo.svg';
const config = {
    title: 'AllPayPays',
    logo: Logo
};
export default config;
